/**
 * /auth/me probe — returns the current session principal or null.
 *
 * Used by the TanStack-Router `beforeLoad` guards on protected routes:
 * if the BFF answers 401 we redirect the browser to /auth/login (the
 * api wrapper does that already), otherwise we surface the user object
 * for menu state.
 */
import { api } from "@/lib/api";

export type MeResponse = {
  sub: string;
  email: string;
  name: string;
  roles: string[];
};

export async function fetchMe(): Promise<MeResponse | null> {
  try {
    return await api<MeResponse>("/auth/me");
  } catch {
    return null;
  }
}
